<template>
    <div>
        <el-tabs v-if="showtabs"
                 style="margin: 10px 10px 0 10px;" 
                 :value="activeName" 
                 @tab-click="handleClick">
            <el-tab-pane :label="$t('message.export')" name="noCompletion"></el-tab-pane>
            <el-tab-pane :label="$t('message.import')" name="completion"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName === 'completion'" class="wrap">
            <div style=" display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin: 20px 0 15px 0;
                        color: rgba(53, 53, 53, 1);"><h2>{{$t('message.masterAccount')}}</h2>
            </div>
            <div style="border: 1px solid #ddd; border-radius: 4px;">
                <div class="titleBox" style="width: 100%; font-weight: 500; background: #f1fbff;">
                    <div class="tit" style="flex: 1; color: #181818;"><label>{{$t('message.accountInfoModifyUserName')}}</label></div>                                         
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.nickname')}}</div>
                    <div class="tit" style="flex: 1; color: #181818;">QQ</div>
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.accountInfoModifyUserPhone')}}</div>                                      
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.mobileNumber')}}</div>
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.weChat')}}</div>
                    <div class="tit" style="flex: 1.1; color: #181818;">{{$t('message.accountInfoModifyUserEmail')}}</div>                                      
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.accountType')}}</div>
                </div> 
                <div v-if="accountMain1.userName"
                     class="titleBox" 
                     style="width: 100%;">
                    <div class="tit" style="flex: 1;"><label>{{accountMain1.userName}}</label></div>                                         
                    <div class="tit" style="flex: 1;">{{accountMain1.nickName}}</div>
                    <div class="tit" style="flex: 1;">{{accountMain1.qq}}</div>
                    <div class="tit" style="flex: 1;">{{accountMain1.phone}}</div>                                      
                    <div class="tit" style="flex: 1; word-break: break-all;">{{accountMain1.mobile}}</div>
                    <div class="tit" style="flex: 1;">{{accountMain1.weChat}}</div>
                    <div class="tit" style="flex: 1.1; word-break: break-all;">{{accountMain1.email}}</div>                                      
                    <div class="tit" style="flex: 1;">{{accountMain1.accountTypeNameC}}</div>
                </div>
                <div v-else style="width: 200px; margin: 20px auto; color: #777; text-align: center;" >{{$t('message.noData')}}</div>
            </div>
            <div style=" display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin: 20px 0 15px 0;
                        color: rgba(53, 53, 53, 1);"><h2>{{$t('message.subAccount')}}</h2>
            </div>
            <div style="border: 1px solid #ddd; border-radius: 4px;">
                <div class="titleBox" style="width: 100%; overflow: hidden; font-weight: 500; background: #f1fbff;">
                    <div class="tit" style="flex: 1; color: #181818;"><label>{{$t('message.accountInfoModifyUserName')}}</label></div>                                         
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.nickname')}}</div>
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.ichargingStandard')}}</div>
                    <div class="tit" :style="{flex: !$isZh() ? '1.2' : '1',color: '#181818'}">{{$t('message.c1ffa')}}</div>                                      
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.mobileNumber')}}</div>
                    <div class="tit" style="flex: 1; color: #181818;">QQ</div>
                    <div class="tit" style="flex: 1; color: #181818;">{{$t('message.accountInfoModifyUserPhone')}}</div>                                      
                    <div class="tit" style="flex: 1.5; color: #181818; box-shadow: rgb(139 139 139 / 38%) -1px 0 5px 0;">{{$t('message.operate')}}</div>
                </div>
                <div v-for="(item,index) in accountSub1"
                     :key="index"
                     class="titleBox t-content" 
                     style="width: 100%;">
                    <div class="tit" style="flex: 1;">{{item.userName}}</div>                                         
                    <div class="tit" style="flex: 1;">{{item.nickName}}</div>
                    <div class="tit" style="flex: 1; text-align: center;">{{item.feeTemplateName}}</div>
                    <div class="tit" :style="{flex: !$isZh() ? '1.2' : '1'}">{{item.mainAccountPay === '0' ? $t('message.b5sdba') : $t('message.not')}}</div>                                      
                    <div class="tit" style="flex: 1; word-break: break-all;">{{item.mobile}}</div>
                    <div class="tit" style="flex: 1;">{{item.qq}}</div>
                    <div class="tit" style="flex: 1;">{{item.phone}}</div>
                    <div class="tit" style="flex: 1.5; box-shadow: rgb(139 139 139 / 38%) -1px 0 5px 0;">
                        <div style="display: flex; justify-content: space-around; width: 100%; line-height: 40px;"><div style="color: rgba(0, 159, 232, 1); cursor: pointer;" 
                                                                                                                        @click="$router.push({path: '/personalCenter/PersonalCenterMain/accountCenter/accountManagement/CreatAccount',query: {userCode: item.userCode}})">{{$t('message.change')}}</div>
                            <div v-if="item.accountStatus === '0'"  
                                 :style="{cursor: 'pointer',color: 'rgba(103, 194, 58, 1)'}"
                                 @click="validAccount($event,item.userName,true,item.userCode)">{{$t('message.b4wdqa')}}</div>
                            <div v-if="item.accountStatus === '1'" 
                                 :style="{cursor: 'pointer',color: 'rgba(231, 26, 64, 1)'}" 
                                 @click="invalidAccount($event,item.userName,true,item.userCode)">{{$t('message.b2wdd1')}}</div>
                            <div style="color: rgba(133, 133, 133, 1); cursor: pointer;"  @click="deleteuser(item.userCode)">{{$t('message.delete')}}</div></div>
                    </div>
                </div> 
                <div v-if="accountSub1.length === 0" style="width: 200px; margin: 20px auto; color: #777; text-align: center;" >{{$t('message.noData')}}</div>
            </div>
            <div class="opeartingBtnBox">
                <el-button  type="primary"
                            class="opeartingBtn"
                            @click="$router.push({path: '/personalCenter/PersonalCenterMain/accountCenter/accountManagement/CreatAccount'})">{{$t('message.b1dsk1')}}</el-button>
            </div>   
           
            <SJMLoading v-if="accountSubLoading" zIndex="11"></SJMLoading>
            
            
        </div>
        <div v-else class="wrap">
            <p class="title">{{companyName}}</p>
            <!-- 主账户 -->
            <div v-if="accType === '1'" class="mainAccountWrap">
                <template v-if="employeeApplyList.length!==0">
                    <p class="tit">{{$t('message.applyJoin')}}</p>
                    <el-table header-row-class-name="tabHead"
                              row-class-name="tabBody"
                              :data="employeeApplyList"
                              border
                              style="width: 100%;">                       
                        <el-table-column prop="username"
                                         :label="$t('message.accountInfoModifyUserName')"
                                         width="100">
                                
                        </el-table-column>
                        <el-table-column prop="nickname"
                                         :label="$t('message.nickname')"
                                         width="110">
                              
                        </el-table-column>
                        <el-table-column prop="mobile"
                                         :label="$t('message.mobileNumber')"
                                         width="200">
                              
                        </el-table-column>
                        <el-table-column prop="email"
                                         :label="$t('message.accountInfoModifyUserEmail')"
                                         width="200">
                            
                        </el-table-column>
                        <el-table-column :label="$t('message.applyJoinTime')">
                               
                            <template slot-scope="scope">
                                {{$moment(Number(scope.row.applyTime)).format('YYYY/MM/DD HH:mm:ss')}}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('message.operate')"
                                         fixed="right"
                                         width="240">
                            <template slot-scope="scope">
                                <el-button size="mini"
                                           type="success"
                                           @click="postReviewResult('1',scope.row)">
                                    {{$t('message.inpectpass')}}
                                </el-button>
                                <el-button size="mini"
                                           type="danger"
                                           @click="postReviewResult('0',scope.row)">
                                    {{$t('message.inpectrefuse')}}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <p class="tit">{{$t('message.masterAccount')}}</p>
                <el-table
                        header-row-class-name="tabHead"
                        row-class-name="tabBody"
                        :data="accountMain"
                        border
                        style="width: 100%;">
                    <el-table-column
                            prop="userName"
                            :label="$t('message.accountInfoModifyUserName')"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="nickName"
                            :label="$t('message.nickname')"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="qq"
                            label="QQ"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            :label="$t('message.accountInfoModifyUserPhone')"
                            width="130">
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            :label="$t('message.accountInfoModifyUserMobile')"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="weChat"
                            :label="$t('message.weChat')">
                    </el-table-column>
                    <el-table-column
                            prop="email"
                            :label="$t('message.accountInfoModifyUserEmail')"
                            width="204">
                    </el-table-column>
                    <el-table-column
                            prop="accountType"
                            :label="$t('message.accountType')"
                            width="155">
                    </el-table-column>
                </el-table>
                <p class="tit">{{$t('message.performanceranking')}}</p>
                <el-table
                        header-row-class-name="tabHead"
                        row-class-name="tabBody"
                        :data="employeeOfficialList"
                        border
                        style="width: 100%;">
                    <el-table-column
                            prop="username"
                            :label="$t('message.accountInfoModifyUserName')"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="nickname"
                            :label="$t('message.nickname')"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            :label="$t('message.mobileNumber')"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            prop="integral"
                            :label="$t('message.integral')"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            prop="orders"
                            :label="$t('message.takeOffNumber')">
                    </el-table-column>
                    <el-table-column :label="$t('message.operate')"
                                     fixed="right"
                                     width="130">
                        <template slot-scope="scope">
                            <el-button  size="mini"
                                        type="primary"
                                        @click="postPrivateFireEmployee(scope.row)">
                                {{$t('message.remove')}}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <p class="tit">{{$t('message.subAccount')}}</p>
                <el-table
                        highlight-current-row
                        header-row-class-name="tabHead"
                        row-class-name="tabBody"
                        :data="accountSub"
                        border
                        :max-height="550.2"
                        style="width: 100%;"
                        @row-click="getSubAccountRow">
                    <el-table-column
                            width="35">
                        <template slot-scope="scope">
                            <el-radio
                                    v-model="subAccountSelection"
                                    :label="scope.row.key"
                                    @change.native="getSubAccountRow(scope.row)">&ensp;
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column
                            type="index"
                            :label="$t('message.index')"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="userName"
                            :label="$t('message.accountInfoModifyUserName')"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="nickName"
                            :label="$t('message.nickname')"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="qq"
                            label="QQ"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            :label="$t('message.accountInfoModifyUserPhone')"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            :label="$t('message.accountInfoModifyUserMobile')"
                            width="130">
                    </el-table-column>
                    <el-table-column
                            prop="weChat"
                            :label="$t('message.weChat')"
                            width="130">
                    </el-table-column>
                    <el-table-column
                            prop="email"
                            :label="$t('message.accountInfoModifyUserEmail')"
                            width="130">
                    </el-table-column>
                    <el-table-column
                            prop="accountTypeNameC"
                            :label="$t('message.accountType')"
                            width="130">
                    </el-table-column>
                    <el-table-column
                            prop="accountStatus"
                            :label="$t('message.accountStatus')"
                            :formatter="formatterAccountStatus"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            prop=""
                            :label="$t('message.option')"
                            fixed="right"
                            width="130">
                        <template slot-scope="scope">
                            <el-button  size="mini"
                                        type="primary"
                                        style="min-width: 110px; margin: 2px 2px;"
                                        @click="resetAccount($event,scope.row.userName)">{{$t('message.resetAccount')}}
                            </el-button>
                            <el-button  v-if="scope.row.accountStatus === '1'"
                                        size="mini"
                                        type="danger"
                                        style="min-width: 110px; margin: 2px 2px;"
                                        @click="invalidAccount($event,scope.row.userName,false)">{{$t('message.invalidAccount')}}
                            </el-button>
                            <el-button  v-else
                                        size="mini"
                                        type="success"
                                        style="min-width: 110px; margin: 2px 2px;"
                                        @click="validAccount($event,scope.row.userName,false)">{{$t('message.validAccount')}}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="mainAccountOperation">
                    <router-link
                            v-if="accountSub.length<20"
                            to="/personalCenter/PersonalCenterMain/accountCenter/accountManagement/SubAccountAddOrReset?addOrReset=0"
                            style="margin-right: 30px;"
                            @click.native="$bigData('addNewSubFunDistribution', '新增分账户', '1')">
                        <el-button type="text">
                            <i class="iconfont icon-xinzeng"></i>
                            <span>{{$t('message.addNew')}}</span>
                        </el-button>
                    </router-link>
                    <el-button  v-if="accountSub.length>0"
                                type="text"
                                @click="subFunDistributionClick">
                        {{$t('message.functionview')}}
                    </el-button>
                </div>
            </div>
            <!-- 分账户 -->
            <div v-if="accType === '0'" class="subAccountWrap">
                <p class="tit">{{$t('message.accountFunction')}}</p>
                <div class="timelineBox">
                    <div class="timeline"></div>
                    <div class="funItemBox">
                        <div    v-for="(item,index) in subTimeLine"
                                :key="index"
                                class="funItem">
                            <img    v-if="item.type==='1'"
                                    src="@/assets/img/personalCenter/accountCenter/accountManagement/accountManagementMain/functionClose.png">
                            <img    v-else
                                    src="@/assets/img/personalCenter/accountCenter/accountManagement/accountManagementMain/functionOpen.png">
                            <span   :class="{close:item.type === '1'}">{{item.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="funWrap">
                    <div v-for="(item,index) in subFunctionDetails"
                         :key="index"
                         class="funBox">
                        <div class="funTit">{{item.name}}</div>
                        <p  v-for="(jtem,jndex) in item.details"
                            :key="jndex"
                            :class="{funItem:true,close:jtem.type === '0'}">{{jtem.name}}</p>
                    </div>
                </div>
            </div>
            
            <SJMLoading v-if="isWrapLoading" zIndex="5"></SJMLoading>
        </div>
        <!-- 敏感操作验证组件 -->
        <SensitiveOperationVer
                :callback="sensitiveCallback"
                :show="showSensitiveOperationVer"></SensitiveOperationVer>
        <el-dialog
                :title="$t('message.bindEmailAndMobile')"
                :visible.sync="isShowNewVerifyDialog"
                width="420px"
                custom-class="all newVerifyDialog">
            <table class="newVerifyTab">
                <tr>
                    <td>{{$t('message.newEmail')}}</td>
                    <td>
                        <el-input   v-model.trim="newEmail"
                                    size="mini"
                                    :disabled="isVerifyEmail"></el-input>
                    </td>
                </tr>
                <tr v-if="!isVerifyEmail">
                    <td></td>
                    <td>
                        <el-button  v-if="!countdown"
                                    size="mini"
                                    @click="getEmailVerify">
                            {{$t('message.getVerificationCode')}}
                        </el-button>
                        <el-button  v-else
                                    size="mini"
                                    :disabled="true">
                            {{verificationSecond}}{{$t('message.retryInSeconds')}}
                        </el-button>
                    </td>
                </tr>
                <tr v-if="!isVerifyEmail">
                    <td>{{$t('message.verificationCode')}}</td>
                    <td>
                        <el-input v-model.trim="emailVerifyCode" size="mini"></el-input>
                    </td>
                </tr>
            </table>
            <div class="btnBox">
                <el-button  v-if="!isVerifyEmail"
                            style="min-width: 75px;"
                            size="mini"
                            type="success"
                            @click="postEmailVerifyCode">{{$t('message.verification')}}
                </el-button>
                <el-button  v-else
                            :disabled="true"
                            style="min-width: 75px;"
                            size="mini"
                            type="success">
                    {{$t('message.verified')}}
                </el-button>
            </div>
            <div v-if="isVerifyEmail">
                <div style="margin: 15px 0; border-top: 1px dashed #808080;"></div>
                <table class="newVerifyTab">
                    <tr>
                        <td>{{$t('message.newMobile')}}</td>
                        <td>
                            <div style="display: flex;">
                                <el-select  v-model="SMSCode"
                                            size="mini"
                                            style="width: 92px;">
                                    <el-option
                                            v-for="item in SMS"
                                            :key="item.value"
                                            :label="`+${item.countryCode}`"
                                            :value="item.countryCode">
                                        <span style="float: left;">{{`${item.countryNameC}${item.codeAbbr}(+${item.countryCode})`}}</span>
                                    </el-option>
                                </el-select>
                                <el-input   v-model.trim="newMobile"
                                            size="mini"
                                            style="flex: 1;"></el-input>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <el-button  v-if="!countdown"
                                        size="mini"
                                        @click="getMobileVerify">
                                {{$t('message.getVerificationCode')}}
                            </el-button>
                            <el-button  v-else
                                        size="mini"
                                        :disabled="true">
                                {{verificationSecond}}{{$t('message.retryInSeconds')}}
                            </el-button>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.verificationCode')}}</td>
                        <td>
                            <el-input v-model.trim="mobileVerifyCode" size="mini"></el-input>
                        </td>
                    </tr>
                </table>
                <div class="btnBox">
                    <el-button  style="min-width: 75px;"
                                size="mini"
                                type="success"
                                @click="postMobileVerifyCode">
                        {{$t('message.verification')}}
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
    
</template>
<script>

    import SensitiveOperationVer from '@/components/personalCenter/SensitiveOperationVer.vue';// 敏感操作验证组件

    import SMS from '@/assets/json/SMS.json';// 短信前缀列表

    export default {
        name: 'AccountManagement',// 账户管理主页
        components: {
            SensitiveOperationVer
        },
        data() {
            return {
                isWrapLoading: true,// 整体加载中
                companyName: '', // 公司名称
                accType: '',// 账户类型 1-主账户、0-分账户
                // 主账户数据
                accountMain: [],
                // 分账户数据
                accountSub: [],
                // 分账户时间轴
                subTimeLine: [],
                // 分账户功能明细
                subFunctionDetails: [],
                // 分账户选中数据key
                subAccountSelection: -1,
                showSensitiveOperationVer: -1,// 显示敏感操作验证组件
                sensitiveCallback: () => {// 敏感操作验证回调
                },
                mobileRegular: this.$store.state.Regular.mobile,// 手机号正则
                emailRegular: this.$store.state.Regular.email,// 邮箱正则
                isShowNewVerifyDialog: false,// 是否显示新绑定弹窗
                getSubAccountVerificationCodeDataAjaxName: null,// 发送验证码AjaxName
                newEmail: '',// 新邮箱
                newMobile: '',// 新手机
                emailVerifyCode: '',// 新邮箱验证码
                mobileVerifyCode: '',// 新手机验证码
                isVerifyEmail: false,// 是否验证新邮箱
                isVerifyMobile: false,// 是否验证新手机
                emailSendCount: 1, // 邮箱验证发送次数
                verificationTimer: null,// 验证码定时器
                verificationSecond: 60,// 验证码当前秒数
                countdown: false,// 是否正在倒数
                openAccountUserName: '',// 当前需要开启的用户名
                SMS: SMS,// 短信前缀列表
                SMSCode: '86',// 短信前缀
                // 待审核列表
                employeeApplyList: [],
                // 员工列表
                employeeOfficialList: [],
                isImport: this.$route.query.isImport, // 是否要选中进口tab
                activeName: 'noCompletion',
                accountSubLoading: false,
                accountSub1: [],
                accountMain1: {},
                importOpen: false, // 是否是进口打开的禁用启用
                userCode: '',
                showtabs: false // 是否显示tab
            };
        },
        watch: {
            // 账户类型
            async accType(newValue) {
                switch (newValue) {
                    case '1':// 主账户
                        // 待审核员工列表
                        this.employeeApplyList = await this.getPrivateEmployeeListDataAjax('0');// 获取待审核员工列表Ajax
                        await this.getAccountMainData();// 获取主+分账户信息Ajax
                        // 正式员工列表
                        this.employeeOfficialList = await this.getPrivateEmployeeListDataAjax('1');// 获取正式员工列表Ajax
                        break;
                    case '0':// 分账户
                        await this.getAccountSubData();// 获取分账号数据Ajax
                        break;
                }
                // 关闭加载中
                this.isWrapLoading = false;
            },
            // 是否显示新绑定弹窗
            isShowNewVerifyDialog(newValue) {
                if (!newValue) {
                    this.initNewSendVerifyCodeFn();// 初始化新绑定发送验证码定时器方法
                    this.newEmail = '';// 新邮箱
                    this.newMobile = '';// 新手机
                    this.isVerifyEmail = false;// 是否验证新邮箱
                    this.isVerifyMobile = false;// 是否验证新手机
                    this.openAccountUserName = '';// 当前需要开启的用户名
                }
            }
        },
        mounted() {
            if (this.$store.state.Login.loginData.exportMain === '1' && this.$store.state.Login.loginData.importMain === '1') {
                this.activeName = 'noCompletion';  
                this.showtabs = true;  
                if (this.isImport && this.isImport === '1') {
                    this.activeName = 'completion';
                    this.getdataList();
                } else {
                    this.getAccountTypeData();// 判断主分账户Ajax
                } 

            } else if (this.$store.state.Login.loginData.exportMain === '1' && this.$store.state.Login.loginData.importMain === '0') {
                this.activeName = 'noCompletion';  
                this.showtabs = false;     
                this.accType = '1';
                // this.getAccountTypeData();// 判断主分账户Ajax            
            } else if (this.$store.state.Login.loginData.exportMain === '0' && this.$store.state.Login.loginData.importMain === '1') {
                this.activeName = 'completion';   
                this.showtabs = false; 
                this.getdataList();              
            } else if (this.$store.state.Login.loginData.exportMain === '0' && this.$store.state.Login.loginData.importMain === '0') {
                this.activeName = 'noCompletion';   
                this.showtabs = false; 
                this.accType = '0';              
            }           
        },
        methods: {
            deleteuser(userCode) {
                this.$Confirm({
                    msg: `${this.$t('message.deleteuser')}`,
                    callback: () => {
                        this.$ajax({
                            url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAccountSubHandler.ashx',
                            data: {
                                act: 'postDelImportAccountData',// 提交删除进口账户的数据
                                userCode: userCode,// 用户CODE
                            },
                            beforeSend: () => {
                                // this.accountSubLoading = true;
                            },
                            success: () => {
                                this.$Message({msg: this.$t('message.deleteSuccess')});
                                this.getdataList();     
                            },
                            complete: () => {
                                // this.accountSubLoading = false;
                            }
                        });
                    }
                });
                
            },
            async handleClick(tab) {
                if (tab.name === this.activeName) {
                    return;
                }
                this.activeName = tab.name;
                if (tab.name === 'noCompletion') {
                    switch (this.accType) {
                        case '1':// 主账户
                            // 待审核员工列表
                            this.employeeApplyList = await this.getPrivateEmployeeListDataAjax('0');// 获取待审核员工列表Ajax
                            await this.getAccountMainData();// 获取主+分账户信息Ajax
                            // 正式员工列表
                            this.employeeOfficialList = await this.getPrivateEmployeeListDataAjax('1');// 获取正式员工列表Ajax
                            break;
                        case '0':// 分账户
                            await this.getAccountSubData();// 获取分账号数据Ajax
                            break;
                    }
                } else {
                    this.getdataList();
                }
               
                
            },
            getdataList() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAccountSubHandler.ashx',
                    data: {
                        act: 'getImportAccountMainManagementData',// 获取进口主账户账户管理的数据
                    },
                    beforeSend: () => {
                        this.accountSubLoading = true;
                    },
                    success: (res) => {
                        this.accountMain1 = res.success.accountMain || {};
                        this.accountSub1 = res.success.accountSub || [];     
                    },
                    complete: () => {
                        this.accountSubLoading = false;
                    }
                });
            },
            // 初始化新绑定发送验证码定时器方法
            initNewSendVerifyCodeFn() {
                this.$ajaxCancel(this.getSubAccountVerificationCodeDataAjaxName);// 取消分账户获取Ajax
                clearInterval(this.verificationTimer);// 初始化定时器
                this.countdown = false;// 结束倒数
                this.verificationSecond = 60;// 初始化倒计时
                this.emailVerifyCode = '';// 新邮箱验证码
                this.mobileVerifyCode = '';// 新手机验证码
            },
            // 判断主分账户Ajax
            getAccountTypeData() {
                this.accType = (this.$store.state.Login.loginData.exportMain === '1' || this.$store.state.Login.loginData.importMain === '1') ? '1' : '0';
                // this.$ajax({
                //     url: '/personalCenterHandler/accountCenter/AccountManagementHandler.ashx',
                //     data: {
                //         act: 'getAccountTypeData'// 判断主分账户
                //     },
                //     success: (res) => {
                //         // 账户类型渲染
                //         this.accType = res.success.accType;
                //     }
                // });
            },
            // 获取主+分账户信息Ajax
            getAccountMainData() {
                return new Promise((resolve) => {
                    this.$ajax({
                        url: '/personalCenterHandler/accountCenter/AccountManagementHandler.ashx',
                        data: {
                            act: 'getAccountMainData'// 主账户！！！获取主+分账户信息
                        },
                        success: (res) => {
                            // 主账户数据
                            res.success.accountMain.accountType = this.$t('message.managementAccount');
                            this.accountMain = [res.success.accountMain];
                            // 分账户数据
                            this.accountSub = res.success.accountSub;
                            resolve();
                        }
                    });
                });
            },
            // 获取分账号数据Ajax
            getAccountSubData() {
                return new Promise((resolve) => {
                    this.$ajax({
                        url: '/personalCenterHandler/accountCenter/AccountManagementHandler.ashx',
                        data: {
                            act: 'getAccountSubData'// 分账户！！！获取分账户权限信息
                        },
                        success: (res) => {
                            // 绑定分账户时间轴数据
                            this.subTimeLine = res.success.timeLine;
                            // 绑定分账户功能明细
                            this.subFunctionDetails = res.success.functionDetails;
                            resolve();
                        }
                    });
                });
            },
            // 格式化账户状态
            formatterAccountStatus(row) {
                if (row.accountStatus === '0') {
                    return this.$createElement('span', {
                        style: 'color:#FF5722'
                    }, this.$t('message.terminated'));
                } else {
                    return this.$createElement('span', {
                        style: 'color:#1eaa39'
                    }, this.$t('message.activated'));
                }
            },
            // 获取分账户选中数据（点击表格or点击左侧选中按钮）
            getSubAccountRow(row) {
                // 绑定点击的index
                this.subAccountSelection = row.key;
            },
            // 分账户功能分配点击
            subFunDistributionClick() {
                // 大数据 个人中心-账户管理-功能分配
                this.$bigData('subFunDistribution', '功能查看', '1');
                if (this.subAccountSelection === -1) {// 未选择分账户
                    this.$Alert({
                        msg: this.$t('message.selectSubAccount'),
                    });
                } else if (this.accountSub[Number(this.subAccountSelection) - 1].accountType === '5') {// 综合账户 无法进行功能分配
                    this.$Alert({
                        msg: this.$t('message.noNeedToAssign'),
                    });
                } else {// 正确进入功能分配
                    this.$router.push({
                        path: '/personalCenter/PersonalCenterMain/accountCenter/accountManagement/FunctionDistribution',
                        query: {
                            accountName: this.accountSub[Number(this.subAccountSelection) - 1].userName
                        }
                    });
                }
            },
            // 重置账户
            resetAccount(ev, userName) {
                ev.stopPropagation();
                this.$Confirm({
                    msg: this.$t('message.isResetAccount'),
                    callback: () => {
                        // 给敏感操作回调赋值
                        this.sensitiveCallback = () => {                      
                            this.resetAccountActive(userName);
                        };
                        // 显示敏感操作验证组件
                        this.showSensitiveOperationVer = +new Date();
                    }
                });
                // 大数据 个人中心-账户管理-重置
                this.$bigData('resetAccount', '重置账户', '1');
            },
            // 重置账户（执行）
            resetAccountActive(userName) {
                this.$router.push({
                    path: '/personalCenter/PersonalCenterMain/accountCenter/accountManagement/SubAccountAddOrReset',
                    query: {
                        addOrReset: '1',
                        userName: userName
                    },
                });
            },
            // 停用账户
            invalidAccount(ev, userName, importOpen, userCode) {
                ev.stopPropagation();
                this.importOpen = importOpen;
                this.$Confirm({
                    msg: `${this.$t('message.deactivateAccount')}<br>${this.importOpen ? '' : this.$t('message.deactivateAccountTips')}`,
                    dangerouslyUseHTMLString: true,
                    callback: () => {
                        if (this.importOpen) {
                            this.$ajax({
                                url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAccountSubHandler.ashx',
                                data: {
                                    act: 'postImportAccountStatusData',// 账户状态修改
                                    userCode: userCode,// 帐户名
                                    type: '0',// 0-停用，1-启用
                                },
                                beforeSend: () => {
                                    
                                },
                                success: async () => {
                                    await this.getdataList();// 获取主+分账户信息Ajax
                                    // this.accountSubLoading = false;// 关闭加载中                             
                                }
                                
                            });
                        } else {
                            // 给敏感操作回调赋值
                            this.sensitiveCallback = () => {
                                this.invalidAccountActive(userName,userCode);
                            };
                            // 显示敏感操作验证组件
                        
                            this.showSensitiveOperationVer = +new Date();
                        }
                       
                    }
                });
                // 大数据 个人中心-账户管理-停用
                this.$bigData('invalidAccount', '停用账户', '1');
            },
            // 停用账户（执行）
            invalidAccountActive(userName,userCode) {
                this.$ajax({
                    url: '/personalCenterHandler/accountCenter/AccountManagementHandler.ashx',
                    data: {
                        act: 'postAccountStatusData',// 账户状态修改
                        accountName: userName,// 帐户名
                        type: '0',// 0-停用，1-启用
                    },
                    beforeSend: () => {
                        if (this.importOpen) {
                            this.accountSubLoading = true;
                        } else {
                            this.isWrapLoading = true;// 打开加载中
                        }
                      
                    },
                    success: async () => {
                        this.$Alert({
                            msg: userName + ' ' + this.$t('message.invalidAccountSuccess'),
                        });
                        if (this.importOpen) {
                            this.$ajax({
                                url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAccountSubHandler.ashx',
                                data: {
                                    act: 'postImportAccountStatusData',// 账户状态修改
                                    userCode: userCode,// 帐户名
                                    type: '0',// 0-停用，1-启用
                                },
                                beforeSend: () => {
                                    
                                },
                                success: async () => {
                                    await this.getdataList();// 获取主+分账户信息Ajax
                                    // this.accountSubLoading = false;// 关闭加载中                             
                                }
                                
                            });
                        } else {                     
                            await this.getAccountMainData();// 获取主+分账户信息Ajax
                            this.isWrapLoading = false;// 关闭加载中
                        }
                        
                    }
                });
            },
            // 启用账户
            validAccount(ev, userName, importOpen, userCode) {
                ev.stopPropagation();
                this.importOpen = importOpen;
                this.$Confirm({
                    msg: this.$t('message.enableAccount'),
                    callback: () => { 
                        if (this.importOpen) {
                            this.$ajax({
                                url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAccountSubHandler.ashx',
                                data: {
                                    act: 'postImportAccountStatusData',// 账户状态修改
                                    userCode: userCode,// 帐户名
                                    type: '1',// 0-停用，1-启用
                                },
                                beforeSend: () => {
                                    this.accountSubLoading = true;
                                },
                                success: async () => {
                                    await this.getdataList();// 获取主+分账户信息Ajax
                                    // this.accountSubLoading = false;// 关闭加载中                             
                                }
                                
                            });
                        } else {
                            this.validAccountActive(userName,userCode);
                        }               
                        
                    }
                });
                // 大数据 个人中心-账户管理-启用
                this.$bigData('validAccount', '启用账户', '1');
            },
            // 启用账户（执行）
            validAccountActive(userName,userCode) {
                // 绑定需要开启的userCode
                this.userCode = userCode;
                // 绑定需要开启的用户名
                this.openAccountUserName = userName;
                // 显示弹窗
                this.isShowNewVerifyDialog = true;
            },
            // 发送邮箱验证码Ajax
            getEmailVerify() {
                if (!this.emailRegular.test(this.newEmail)) {
                    this.$Alert({
                        msg: this.$t('message.errEmail')
                    });
                    return;
                }
                // 分账户发送验证码Ajax（邮箱）
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        name: 'getSubAccountVerificationCodeDataAjaxName',
                        act: 'getSubAccountVerificationCodeData',// 分账户获取验证码
                        type: '0',// 0-启用、1-新增、2-重置
                        userName: this.openAccountUserName,// 分账户账户名（新增不发送该字段）
                        method: 'email',// email-邮箱、mobile-手机
                        sendInfo: this.newEmail,// 邮箱、手机号
                        emailSendCount: Number(this.emailSendCount)// 获取邮箱验证码点击的次数
                    },
                    beforeSend: () => {
                        this.countdown = true;// 开始倒数
                    },
                    errCallback: () => {
                        this.countdown = false;// 结束倒数
                        this.verificationSecond = 60;// 初始化
                    },
                    success: () => {
                        // 倒计时
                        this.verificationTimer = setInterval(() => {
                            if (this.verificationSecond === 0) {
                                clearInterval(this.verificationTimer);// 初始化定时器
                                this.countdown = false;// 结束倒数
                                this.verificationSecond = 60;// 初始化
                                return;
                            }
                            this.verificationSecond--;
                        }, 1000);
                    },
                    complete: () => {
                        // 邮箱验证码次数++
                        this.emailSendCount++;
                    }
                });
            },
            // 验证邮箱验证码
            postEmailVerifyCode() {
                // 分账户 验证 验证码
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'postSubAccountVerificationCodeData',// 分账户 验证 验证码
                        type: '0',// 0-启用、1-新增、2-重置
                        userName: this.openAccountUserName,// 账户名（新增时不发送）
                        method: 'email',// email-邮箱、mobile-手机
                        verificationCode: this.emailVerifyCode,// 验证码
                        sendInfo: this.newEmail,// 邮箱、手机号
                    },
                    success: () => {
                        this.initNewSendVerifyCodeFn();// 初始化新绑定发送验证码定时器方法
                        this.emailSendCount = 1; // 邮箱验证发送次数
                        this.isVerifyEmail = true;// 邮箱已验证
                    }
                });
            },
            // 发送手机验证码Ajax
            getMobileVerify() {
                if (!this.mobileRegular.test(this.newMobile)) {
                    this.$Alert({
                        msg: this.$t('message.errMobile')
                    });
                    return;
                }
                // 分账户发送验证码Ajax（手机）
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        name: 'getSubAccountVerificationCodeDataAjaxName',
                        act: 'getSubAccountVerificationCodeData',// 分账户获取验证码
                        type: '0',// 0-启用、1-新增、2-重置
                        userName: this.openAccountUserName,// 分账户账户名（新增不发送该字段）
                        method: 'mobile',// email-邮箱、mobile-手机
                        sendInfo: `+${this.SMSCode}-${this.newMobile}`,// 邮箱、手机号
                    },
                    beforeSend: () => {
                        this.countdown = true;// 开始倒数
                    },
                    errCallback: () => {
                        this.countdown = false;// 结束倒数
                        this.verificationSecond = 60;// 初始化
                    },
                    success: () => {
                        // 倒计时
                        this.verificationTimer = setInterval(() => {
                            if (this.verificationSecond === 0) {
                                clearInterval(this.verificationTimer);// 初始化定时器
                                this.countdown = false;// 结束倒数
                                this.verificationSecond = 60;// 初始化
                                return;
                            }
                            this.verificationSecond--;
                        }, 1000);
                    }
                });
            },
            // 验证手机验证码
            postMobileVerifyCode() {
                // 分账户 验证 验证码
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'postSubAccountVerificationCodeData',// 分账户 验证 验证码
                        type: '0',// 0-启用、1-新增、2-重置
                        userName: this.openAccountUserName,// 账户名（新增时不发送）
                        method: 'mobile',// email-邮箱、mobile-手机
                        verificationCode: this.mobileVerifyCode,// 验证码
                        sendInfo: `+${this.SMSCode}-${this.newMobile}`,// 邮箱、手机号
                    },
                    success: () => {
                        this.openAccountActiveAjax();// 开启分账户及绑定邮箱手机Ajax
                    }
                });
            },
            // 开启分账户及绑定邮箱手机Ajax
            openAccountActiveAjax() {
                this.$ajax({
                    url: '/personalCenterHandler/accountCenter/AccountManagementHandler.ashx',
                    data: {
                        act: 'postAccountStatusData',// 账户状态修改
                        accountName: this.openAccountUserName,// 帐户名
                        type: '1',// 0-停用，1-启用
                        email: this.newEmail,// 邮箱 若为停用则不传
                        mobile: `+${this.SMSCode}-${this.newMobile}`// 手机 若为停用则不传
                    },
                    success: async () => {
                        this.$Alert({
                            msg: this.openAccountUserName + ' ' + this.$t('message.enableAccountSuccess'),
                        });
                        this.isShowNewVerifyDialog = false;// 关闭新绑定弹窗
                       
                        if (this.importOpen) {
                            this.$ajax({
                                url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAccountSubHandler.ashx',
                                data: {
                                    act: 'postImportAccountStatusData',// 账户状态修改
                                    userCode: this.userCode,// 帐户名
                                    type: '1',// 0-停用，1-启用
                                },
                                beforeSend: () => {
                                    this.accountSubLoading = true;
                                },
                                success: async () => {
                                    await this.getdataList();// 获取主+分账户信息Ajax
                                    // this.accountSubLoading = false;// 关闭加载中                             
                                }
                                
                            });
                        } else {
                            this.isWrapLoading = true;// 显示加载中
                            await this.getAccountMainData();// 获取主+分账户信息Ajax
                            this.isWrapLoading = false;// 关闭加载中
                        }
                        
                    }
                });
            },
            // 获取员工列表ajax
            getPrivateEmployeeListDataAjax(type) {
                return new Promise((resolve) => {
                    this.$ajax({
                        url: '/PrivateAccountHandler/PrivateCompanyHandler.ashx',
                        data: {
                            act: 'getPrivateEmployeeListData',// 获取员工列表的数据
                            type: type,// 0-待审核、1-正式
                        },
                        success: (res) => {
                            this.companyName = res.success.companyName; // 公司名称
                            resolve(res.success.employeeList);
                        }
                    });
                });
            },
            // 提交审核结果
            postReviewResult(result, row) {
                let message = '';
                if (result === '0') {
                    message = `是否拒绝${row.username}加入贵公司？`;
                    this.$bigData('审核拒绝', '审核拒绝', row.username);
                } else if (result === '1') {
                    message = `是否确认${row.username}加入贵公司？（加入后该账号所有行为将代表贵公司行为）`;
                    this.$bigData('审核通过', '审核通过', row.username);
                }
                // 二次确认
                this.$Confirm({
                    msg: message,
                    callback: () => {
                        // 提交审核结果ajax
                        this.postReviewResultAjax(result, row);
                    },
                });
            },
            // 提交审核结果ajax
            postReviewResultAjax(result, row) {
                this.$ajax({
                    url: '/PrivateAccountHandler/PrivateCompanyHandler.ashx',
                    data: {
                        act: 'postPrivateReviewEmployeeData',// 提交审核员工的数据
                        reviewResults: result,// 审核结果 0-未通过、1-通过
                        username: row.username,
                    },
                    beforeSend: () => {
                        this.isWrapLoading = true;// 打开加载中
                    },
                    complete: () => {
                        this.isWrapLoading = false;// 关闭加载中
                    },
                    success: () => {
                        this.$Alert({
                            msg: '操作成功！',
                            callback: () => {
                                // 刷新当前子组件
                                this.$centerReload();
                            }
                        });
                    }
                });
            },
            // 解雇员工
            postPrivateFireEmployee(row) {
                this.$bigData('移除员工', '移除员工', row.username);
                // 二次确认
                this.$Confirm({
                    msg: '是否将该员工移出贵公司？（若该员工有未完成订单将自动转到本账户下）',
                    callback: () => {
                        // 解雇员工ajax
                        this.postPrivateFireEmployeeAjax(row);
                    },
                });
            },
            // 解雇员工ajax
            postPrivateFireEmployeeAjax(row) {
                this.$ajax({
                    url: '/PrivateAccountHandler/PrivateCompanyHandler.ashx',
                    data: {       
                        act: 'postPrivateFireEmployeeData',// 提交解雇员工的数据
                        username: row.username,
                    },
                    beforeSend: () => {
                        this.isWrapLoading = true;// 打开加载中
                    },
                    complete: () => {
                        this.isWrapLoading = false;// 关闭加载中
                    },
                    success: () => {
                        this.$Alert({
                            msg: '操作成功！',
                            callback: () => {
                                // 刷新当前子组件
                                this.$centerReload();
                            }
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
        box-shadow: none;
    }

    .wrap {
        position: relative;
        box-sizing: border-box;
        width: 1070px;
        min-height: 783px;
        padding: 0 10px;

        .opeartingBtnBox {
            display: flex;
            justify-content: flex-end;
            margin-top: 30px;

            .opeartingBtn {
                font-size: 16px;
            }
        }

        .titleBox {
            display: flex;

            .tit {
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 40px;
                color: rgba(87, 87, 87, 1);
            }
        }

        .t-content {
            overflow: hidden;
            border-bottom: 1px solid rgb(221, 221, 221);
        }

        .t-content:nth-last-of-type(1) {
            border-bottom: none;
        }

        /* overflow: hidden; */

        .title {
            margin: 20px 0;
            font-size: 38px;
            font-weight: bold;
            text-align: center;
            letter-spacing: 5px;
        }

        .mainAccountWrap {
            position: relative;

            /deep/ .tabHead th {
                text-align: center;
                background-color: #e3eff5;
            }

            /deep/ .tabBody td {
                text-align: center;
            }

            /deep/ .tabBody .cell {
                text-overflow: clip;
            }

            .mainAccountOperation {
                box-sizing: border-box;
                padding-right: 20px;
                margin: 30px 0 20px;
                text-align: right;
            }

            > .tit {
                margin: 20px 0 8px 28px;
                font-size: 18px;
                font-weight: bold;
                color: #0094dd;
            }
        }

        .subAccountWrap {
            position: relative;
            box-sizing: border-box;
            margin: 0 5px;

            > .tit {
                margin: 50px 0 0 30px;
                font-size: 15px;
            }

            .timelineBox {
                position: relative;
                box-sizing: border-box;
                padding: 0 37px;
                margin-bottom: 44px;
                border-bottom: 1px dashed #717071;

                .timeline {
                    position: absolute;
                    top: 39%;
                    left: 50%;
                    width: 900px;
                    height: 6px;
                    background-color: #717071;
                    transform: translate(-50%, -50%);
                }

                .funItemBox {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 160px;

                    .funItem {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        width: 80px;
                        height: 90px;
                        font-size: 15px;
                        text-align: center;

                        .close {
                            color: #9e9e9f;
                        }

                        > img {
                            width: 53px;
                            height: 53px;
                            margin: 0 auto 12px;
                        }
                    }
                }
            }

            .funWrap {
                display: flex;
                justify-content: space-between;

                .funBox {
                    flex: 1;
                    text-align: center;
                    border-right: 1px solid #717071;

                    .funTit {
                        box-sizing: border-box;
                        display: inline-block;
                        max-width: 200px;
                        height: 36px;
                        padding: 0 10px;
                        margin: 0 auto;
                        overflow: hidden;
                        font-size: 17px;
                        line-height: 36px;
                        color: #009fe8;
                        text-align: center;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        border: 1px solid #3e3a39;
                    }

                    .funItem {
                        margin: 16px 0 0 0;
                        font-size: 15px;

                        &.close {
                            color: #c8c9ca;
                        }
                    }
                }

                .funBox:last-child {
                    border-right: none;
                }
            }
        }
    }

    /deep/ .all.newVerifyDialog {
        position: absolute;
        top: 45%;
        left: 50%;
        margin-top: 0 !important;
        transform: translate(-50%, -50%);

        .el-dialog__body {
            padding: 0 20px 20px;
        }

        .newVerifyTab {
            width: 100%;

            tr {
                height: 35px;

                td:nth-child(1) {
                    width: 115px;
                    text-align: right;
                }

                td:nth-child(2) {
                    text-align: left;
                }
            }
        }

        .btnBox {
            display: flex;
            justify-content: center;
            margin-top: 15px;
        }
    }
</style>
